/**
 * FleetFigure — how big a fleet is and how much of it is unreachable: one dot per device, red
 * where it is offline.
 */

import type { ReactElement } from 'react';
import React from 'react';

import type { FleetInfo, LauncherFigurePart } from '@/types/panels';
import type { LauncherTileSize } from '@/types/panels';

import { FigureLegend } from './FigureLegend';
import { getCountedNoun } from './launcherInfo';
import { StatusDots } from './StatusDots';
import { TileFigure } from './TileFigure';

interface Props {
    info: FleetInfo;
    size: LauncherTileSize;
}

export const FleetFigure = ({ info, size }: Props): ReactElement => {
    const parts: LauncherFigurePart[] = [
        { label: 'online', count: info.total - info.offline, fill: 'bg-occ-green-1000' },
        { label: 'offline', count: info.offline, fill: 'bg-occ-red-1000' },
    ];
    return (
        <TileFigure
            size={size}
            value={String(info.total)}
            unit={getCountedNoun(info.total, info.noun)}
            graphic={(
                <StatusDots
                    parts={parts}
                    size={size}
                />
            )}
            legend={<FigureLegend parts={parts} />}
            brief={info.offline === 0
                ? 'All online'
                : `${info.offline} of ${info.total} offline`}
        />
    );
};
